import styled from '@emotion/styled';
import {DisplayLargeTypography} from "patient-ping-remedy/packages/typography";

export const ButtonContainer = styled.div`
    display: flex;
    gap: 1rem;
    margin-bottom: 2.5rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid #ccc;
    
    .css-ccojny  {
        border-bottom: none !important;
    }
    
    button {
        text-transform: none !important;
        font-size: 16px !important;
    }
`;

export const HeaderWithExportContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 2rem;
`;

export const FiltersAndTabsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const ExportButtonWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  padding-bottom: 0.5rem;
  
  button {
    text-transform: none !important;
    font-size: 16px !important;
  }
`;

export const FiltersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const CountBoxContainer = styled.div`
  display: flex;
  gap: 40px;
  margin-bottom: 3rem;
  flex-wrap: wrap;
  align-items: flex-start;
`;

export const CountBox = styled.div`
  border: 1px solid #BBBBBB;
  border-radius: 12px;
  background: #fff;
  padding: 24px;
  width: 400px;
  height: 156px;

  display: flex;
  flex-direction: column;
`;

export const CountTopLabel = styled.div`
  color: #4B5563;
    width: 214px;
    height: 24px;
    margin-bottom: 18px;
`;

export const CountNumber = styled.div`
  font-size: 40px;
  font-weight: 600;
    width: 22px;
    height: 40px;
    line-height: 1;
  color: #111827;
  margin-bottom: 12px;
`;

export const CountBottomLabel = styled.div`
  font-size: 18px;
  color: #6B7280;
  font-weight: 500;
`;

export const TableContainer = styled.div`
  margin-bottom: 3rem;
`;

export const StyledDisplayLargeTypography = styled(DisplayLargeTypography)`
    font-weight: 600;
    padding-bottom: 1rem;
`;
